import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import styles from './index.module.scss';
import ArticleFreeBlock from './article_free_block';
import { useAuthorAvatarsFromPublication } from '../../../../hooks/useAuthorAvatarsFromPublication';
import {
  setTabOrPublicationPage,
  setLastPublicationNumber,
} from '../../../../redux/slices/appSlice';
import { setCurrentPublication } from '../../../../redux/slices/currentPublicationSlice';
import { findCardBlock } from '../../../../utils/findCardBlock';

const ArticleFreeCard = ({ publication, globalIndex }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentTab = useSelector((state) => state.currentTab.currentTab);
  const imgs_for_filters = useSelector((state) => state.others_data.imgs_for_filters);
  const [publicationData, setPublicationData] = React.useState(null);
  const [contentData, setContentData] = React.useState(null);

  React.useEffect(() => {
    if (publication) {
      setPublicationData(publication);
    }
  }, [publication]);

  React.useEffect(() => {
    if (!publicationData?.content) {
      setContentData(null);
      return;
    }

    try {
      const parsed =
        typeof publicationData.content === 'string'
          ? JSON.parse(publicationData.content)
          : publicationData.content;
      setContentData(Array.isArray(parsed) ? parsed : null);
    } catch {
      setContentData(null);
    }
  }, [publicationData]);

  const handleDetailsClick = () => {
    if (!publicationData || !currentTab) return;

    const targetPath =
      currentTab.eng_name === 'main_tab'
        ? `/${publicationData.eng_name}`
        : `/${currentTab.eng_name}/${publicationData.eng_name}`;

    if (globalIndex) {
      dispatch(setLastPublicationNumber(globalIndex));
    }

    dispatch(setCurrentPublication(publicationData));
    dispatch(setTabOrPublicationPage('publication'));
    navigate(targetPath);
  };

  const cardBlock = React.useMemo(
    () => findCardBlock(contentData, publicationData?.template),
    [contentData, publicationData?.template],
  );
  const authorAvatars = useAuthorAvatarsFromPublication(publication);

  const filterA = React.useMemo(() => {
    if (!publication?.publication_settings) return null;
    try {
      const settings = JSON.parse(publication.publication_settings);
      return settings.publication_filter_a || null;
    } catch {
      return null;
    }
  }, [publication?.publication_settings]);

  const filterB = React.useMemo(() => {
    if (!publication?.publication_settings) return null;
    try {
      const settings = JSON.parse(publication.publication_settings);
      return settings.publication_filter_b || null;
    } catch {
      return null;
    }
  }, [publication?.publication_settings]);

  const pathToFolder =
    publicationData?.path && publicationData?.eng_name
      ? `https://${publicationData.path}${publicationData.eng_name}/`
      : '';

  return (
    <div className={styles.articleFreeCard}>
      {cardBlock ? (
        <ArticleFreeBlock
          blockData={cardBlock}
          path_to_folder={pathToFolder}
          onDetailsClick={handleDetailsClick}
          authorAvatars={authorAvatars}
          filterA={filterA}
          filterB={filterB}
          imgs_for_filters={imgs_for_filters}
        />
      ) : (
        <div className={styles.noBlocksMessage}>Блоки не найдены</div>
      )}
    </div>
  );
};

export default ArticleFreeCard;
